import { useEffect, useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { uploadFile } from 'utils/uploadUtils';
import { getConvertedFileSize, staticImagesUrls } from 'utils/helper';
import { truncate } from 'lodash';
import { selectIsMobile } from 'redux/selectors/layout';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

export const AttachedFile = (props) => {
  const {
    currentFile: {
      file,
      signedUrl,
    },
    handleOnUnpinFile,
    updateSelectedFileInfo,
  } = props;

  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const isMobile = useSelector(selectIsMobile);

  useEffect(() => {
    if (isFileUploaded) return;

    uploadFile(
      signedUrl,
      file,
      () => {
        updateSelectedFileInfo(signedUrl);
        setIsFileUploaded(true);
      },
    );
  }, [
    isFileUploaded,
    file,
    signedUrl,
    updateSelectedFileInfo,
  ]);

  return (
    <div
      className={styles.file}
      key={`file/${file.name}`}
    >
      <span className={cn(styles.uploading, {
        [styles.successUploading]: isFileUploaded,
      })}
      >
        {isMobile ? truncate(file.name, { length: 20 }) : file.name}
      </span>
      <span className={cn(styles.uploading, {
        [styles.successUploading]: isFileUploaded,
      })}
      >
        {getConvertedFileSize(file.size)}
      </span>
      <button
        className={cn(styles.uploading, {
          [styles.successUploading]: isFileUploaded,
        })}
        style={{ backgroundImage: `url(${staticImagesUrls.unpinFile})` }}
        data-file-name={file.name}
        type="button"
        onClick={handleOnUnpinFile}
        disabled={!isFileUploaded}
        aria-label="Unpin"
      />
    </div>
  );
};

AttachedFile.propTypes = {
  currentFile: PropTypes.shape({
    file: PropTypes.instanceOf(Object).isRequired,
    signedUrl: PropTypes.string.isRequired,
  }).isRequired,
  handleOnUnpinFile: PropTypes.func.isRequired,
  updateSelectedFileInfo: PropTypes.func.isRequired,
};
